module.exports = "<i kd-checkbox__icon></i>\r\n<label kd-checkbox__label\r\n    ng-transclude></label>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/kendu/ui/components/kd-checkbox/template.html
// module id = 295
// module chunks = 0